import React, { useState } from 'react'
import { motion } from 'framer-motion'

const schedule = [
  { 
    time: '9:00 صباحاً', 
    title: 'التسجيل والتواصل', 
    type: '', 
    location:'مسرح الملتقى - بهو الجامعة',
  },
  {
    time: '10:00 صباحاً',
    title: ' السلام الملكي- القرآن الكريم - المقدمة',
    type: ''
  },
  { time: '10:05 صباحاً',
    title: 'عميدة تطوير المهارات: تنمية القدرات وصناعة المستقبل',
    type: 'الكلمــات الافتتاحية',
    name1: 'د. رانيه بنت إبراهيم الجديد'
  },
  { time: '10:10 صباحاً',
    title: 'كبير مسؤولي الموارد البشرية: الاستثمار في رأس المال البشري ركيزة التحول',
    type: 'الكلمــات الافتتاحية',
    name1: 'عبدالمجيد بن محمد القصيبي'
  },
  {
    time: '10:15 صباحاً',
    title: 'رئيــس جامعــة الملــك ســعود المكلف :الاستثمار فــي القــدرات البشــرية: ريــادة ّ فــي التحــول وصياغــة للأفاق', 
    type: 'الكلمــات الافتتاحية',
    name1: 'أ.د. علي بن محمد مسملي'
  },
  // {
  //   time: '10:20 صباحاً',
  //   title: 'كلمة راعي الحفل',
  //   type: 'الكلمــات الافتتاحية',
  //   name: 'معالي الأستاذ. يوسف بن عبد الله البنيان'
  // },
  {
    time: '10:25 صباحاً',
    title: 'إطلاق برنامج تمكين المهارات: رؤية تصنع المستقبل، ومبادرات تعزز الكفاءة الوطنية',
    type: 'مبادرات وبرامج'
  },
  { time: '10:50 صباحاً',
    title: 'تطوير القادة على كافة المستويات: الانتقال من مسار «القيادي التقليدي» إلى ثقافة «القيادة المؤسسية »', 
    type: 'كلمة رئيسية',
    name1: 'د. إبراهيم سعد المعجل'
  },
  {
    time: '11:20 صباحاً',
    title: 'تكريم الشركاء',
    type: '',
    location: 'قاعة حمد الجاسر - بهو الجامعة'
  },
  {
    time: '11:30 صباحاً',
    title: 'الافتتاح وجولة في المعرض',
    type: ''
  },
  {
    time: '12:00 مساءً',
    title: 'استراحة صلاة الظهر',
    type: 'استراحة'
  },
  {
    time: '12:30 مساءً',
    title: 'تمكين الإنسان: تحوّلٌ في الفكر، وقيادة تصنع الأثر الوطني', 
    type: 'حوار تفاعلي' ,
    name1: 'د. عبد الرحمن بن مكمي الرويلي'
  },
  {
    time: '1:00 مساءً', 
    title: 'من أروقة الجامعة إلى منصات القيادة', 
    type: 'مسيرة خريج' ,
    name1: 'أ. مازن الضراب'
  },
  {
    time: '1:30 مساءً',
    title: 'قيادة المشاريع: من التنفيذ إلى صناعة الفارق',
    type: 'كلمة رئيسية' ,
    name1: 'أ. هاني الشاذلي'
  },
  {
    time: '2:00 مساءً',
    title: 'منهج القدرات: قيادة المؤسسات لمستقبل التنافسية',
    type: 'جلسة حوارية',
    name1: 'أ. صفاء بنت عبد الله الراشد',
    name2: 'أ.د. علي بن أحمد أبو شرحة',
    name3: 'أ.د. خالدالعصفور',
    name4: 'د. هدى عبد الله بن سعيدان'
  },
  {
    time: '2:30 مساءً',
    title: 'رحلة البطل في ألف خطوة',
    type: 'قصة ملهمة',
    name1: 'أ.د. راكان إبراهيم ناظر'
  },
  {
    time: '3:00 مساءً',
    title: 'استراحة صلاة العصر',
    type: 'استراحة' 
  },
  {
    time: '3:30 مساءً',
    title: 'شريكك في النجاح : أنت تسأل .. ونحن نجيب',
    type: 'حوار مفتوح' ,
    name1: 'أ. صيتة السهلي',
    name1: 'أ. منيره عبد الله الحمادي',
    name1: 'أ. تركي الخطاف',
    name1: 'أ. رنا العريني'
  }
]
const schedule2 = [
  {
    time: '9:30 صباحاً',
    title: 'القيادة والثقافة المؤسسية',
    type: 'جلسة حوارية',
    name1: 'أ. ايمان الزعبي',
    name2: 'أ. عبد الله الشمراني',
    name3: 'أ. مروان البازعي'
  },
  {
    time: '10:15 صباحاً',
    title: 'مــن مقاعــد الجامعــة إلــى صناعــة الفــرص: كيــف تصنــع مســارك المهنــي بيــدك', 
    type: 'مسيرة خريج',
    name1: 'أ. سامي الوهدان'
  },
  {
    time: '10:45 صباحاً',
    title: 'القيادة في عصر الذكاء االصطناعي',
    type: 'جلسة حوارية',
    name1: 'د. تغريد السراج',
    name2: 'د. يسرى بنت سعود المتحمي',
    name3: 'د. منيرة العيسى'
  },
  {
    time: '11:30 صباحاً',
    title: 'صناعة الأثر : التمكين بوابة النجاح',
    type: 'قصة ملهمة',
    name1: 'أ. عبدالمجيد العنزي'
  },
  {
    time: '12:00 مساءً',
    title: 'استراحة صلاة الظهر', type: 'استراحة'
  },
  {
    time: '12:30 مساءً',
    title: 'اتجاهات السوق المحلي: المهارات المطلوبة للمستقبل',
    type: 'كلمة رئيسية',
    name1: 'م. سليمان الهويسين'
  },
  {
    time: '1:00 مساءً',
    title: 'رحلة التحول الرقمي للمشتريات الحكومية من التحديات إلى الريادة',
    type: 'قصة ملهمة',
    name1: 'أ. عبدالله الحيان'
  },
  {
    time: '1:30 مساءً',
    title: 'التدريب وتطوير المهارات:أسئلة وأجوبة مع PM',
    type: 'حوار تفاعلي',
    name1: 'أ. محمد بطراوي',
    name2: 'أ. رودولف جوزف خوري'
  },
  {
    time: '2:00 مساءً',
    title: 'وطن طموح يحتضن الطموح',
    type: 'جلسة حوارية',
    name1: 'أ. هـيـثــم عبد الرحمن الضـويــان',
    name2: 'أ. سارة عبد الله آل الشيخ'
  },
  {
    time: '2:30 مساءً',
    title: 'مـــبــــــادرة رحـــلــــــة مبـتــعـــــث',
    type: '',
    name1: 'د. محمد الراجحي',
  },
  {
    time: '3:00 مساءً',
    title: 'شريكك في النجاح : أنت تسأل .. ونحن نجيب',
    type: 'حوار مفتوح',
    name1: 'أ. عبد المجيد العضياني',
    name2: 'أ. هيا الدوسري',
    name3: 'أ. أسامة الموسى',
    name4: 'أ. هناء الجنيدل'
    },
]
const schedule3 = [
  {
    time: '9:30 صباحاً',
    title: 'من التدريب إلى الأثر: دور القيادات في صناعة التغيير',
    type: 'جلسة حوارية',
    name1: 'أ. عبدالمجيد بن محمد القصيبي',
    name2: 'أ. تـوفـيــق الغامــدي',
    name3: 'د. مبارك البقمي',
    name4: 'د. خلود العبدالكريم'
  },
  {
    time: '10:15 صباحاً',
    title: 'ما بعد الشهادات: كيف تصنع التجارب عقليتنا المهنية ؟',
    type: 'مسيرة خريج',
    name1: 'أ. أسماء الشميمري'
  },
  {
    time: '10:45 صباحاً',
    title: 'الإرشاد للمستقبل: دور المجتمع في تمكين القدرات وصناعة قادة التغيير',
    type: 'جلسة حوارية',
    name1: 'د. صالح الحارثي',
    name2: 'د. بثينة بنت محمد الثويني',
    name3: 'أ. معيض بن ناصر البيشي'
  },
  {
    time: '11:30 صباحاً',
    title: 'الإنسان أولاً: الاستثمار في رأس المال البشري لتحقيق أهداف التنمية المستدامة',
    type: 'كلمة رئيسية',
    },
  {
    time: '12:00 مساءً',
     title: 'استراحة صلاة الظهر',
     type: 'استراحة'
    },
  {
    time: '12:30 مساءً',
    title: 'بناء مجتمعات قادرة على مواجهة تحديات المستقبل', 
    type: 'كلمة رئيسة',
    name1: 'أ. سوميا كانان'
  },
  {
    time: '1:00 مساءً',
    title: 'التدريب رافعة التحول المجتمعي لتسريع تحقيق أهداف التنمية المستدامة',
     type: 'جلسة حوارية',
     name1: 'أ. ساره عجي الصحبي',
     name2: 'د. نادية عبد الله الشهراني',
     name3: 'أ. غادة حمد المطلق',
     name4: 'أ. نزار العوفي',
    },
  {
    time: '1:45 مساءً',
    title: 'مواجهة الإعاقة بشغف اللغات',
    type: 'قصة ملهمة',
    name1: 'أ. عبدالله المديميغ'
  },
  {
    time: '2:15 مساءً',
     title: 'ماذا بعد؟ توصيات لبناء منظومة تدريب مستدامة',
     type: 'جلسة حوارية',
     name1: 'د. هديل بنت علي زين العابدين',
     name2: 'د. فهد الفيفي',
     name3: 'أ. ناصر السهلي',
     name4: 'د. البندري بنت حسن الجميل'
    },
  {
    time: '3:00 مساءً',
    title: 'استراحة صلاة العصر',
    type: 'استراحة'
   },
  {
    time: '3:30 مساءً',
     title: 'رسالة شكر ... ووعد بالمستقبل',
     type: 'كلمة ختامية',
     name1: 'د. رانيه بنت إبراهيم الجديد'
    },
  {
    time: '3:35 مساءً',
    title: 'تكريم الفريق',
     type: 'ختام الملتقى'
   }
]

export default function Day() {

const stripContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.3, // ⏱️ ثانية كاملة بين كل كارد
    },
  },
}
const stripItem = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: 0.98,
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1], // smooth editorial easing
    },
  },
}

  
  const tabs = [
    { label: 'اليوم الأول', sub: '19 يناير', data: schedule },
    { label: 'اليوم الثاني', sub: '20 يناير', data: schedule2 },
    { label: 'اليوم الثالث', sub: '21 يناير', data: schedule3 },
  ]

  const [activeIndex, setActiveIndex] = useState(0)
  const activeSchedule = tabs[activeIndex].data

  return (
    <div>

      {/* <section className="relative bg-[#f7f8fa] py-24 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">

          <div className="text-center mb-14">
            <p className="inline-block rounded-full border border-slate-200 bg-white px-5 py-2 text-slate-600 text-sm font-semibold">
              جدول الأيام
            </p>

            <h1 className="mt-8 text-4xl sm:text-5xl font-extrabold text-slate-900 leading-tight">
              بناء القدرات لمستقبل
              <span className="relative inline-block mx-2">
                <span className="relative z-10">تنافسي</span>
                <svg className="absolute -bottom-2 left-0 w-full h-4 text-sky-400/40" viewBox="0 0 200 20">
                  <path d="M0,10 Q50,5 100,10 T200,10" fill="none" stroke="currentColor" strokeWidth="12" />
                </svg>
              </span>
            </h1>

            <p className="mt-2 text-lg text-slate-500">
              المسرح الرئيسي
            </p>
          </div>

          <div className="relative mb-12" dir="rtl">
            <div className="absolute inset-0 rounded-2xl bg-white shadow-sm ring-1 ring-slate-200" />
            <div className="relative grid grid-cols-3 overflow-hidden rounded-2xl text-center text-sm font-semibold text-slate-600">
              <div
                className="absolute inset-y-0 right-0 w-1/3 bg-sky-100 transition-all duration-300 ease-out"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              />
              {tabs.map((tab, idx) => (
                <button
                  key={tab.label}
                  type="button"
                  onClick={() => setActiveIndex(idx)}
                  className={`relative z-10 px-4 py-4 transition ${
                    activeIndex === idx ? 'text-sky-800' : 'text-slate-600 hover:text-slate-800'
                  }`}
                >
                  <div className="text-base font-bold">{tab.label}</div>
                  <div className="text-xs font-medium text-slate-500 mt-1">{tab.sub}</div>
                </button>
              ))}
            </div>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {activeSchedule.map((item, index) => (
              <div
                key={`${item.time}-${index}`}
                className="group relative overflow-hidden rounded-2xl bg-white px-8 py-6 shadow-sm ring-1 ring-slate-200 transition hover:shadow-md"
              >
                <div className="absolute inset-y-0 right-0 w-[3px] bg-slate-300/60" />

                <div className="flex flex-col gap-4">
                <div className="flex gap-2 justify-between">
                  <div className="flex items-center gap-3 text-slate-700">
                    <div className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      >
                        <circle cx="12" cy="12" r="9" />
                        <path d="M12 7v5l3 2" strokeLinecap="round" />
                      </svg>
                    </div>
                    <span className="font-bold text-base">
                      {item.time}
                    </span>
                  </div>

                  {item.type && (
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      >
                        <path
                          d="M7 7h6l4 4-7 7-4-4V7Z"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle cx="9.5" cy="9.5" r="0.5" fill="currentColor" />
                      </svg>
                      <span className="font-medium">
                        {item.type}
                      </span>
                    </div>
                  )}
                  </div>

                  <p className="text-lg leading-relaxed text-slate-900">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

<motion.div
  key={activeIndex}   // 🔥 هذا هو الحل
  variants={stripContainer}
  initial="hidden"
  animate="show"
>

  <div className="px-4 sm:px-8 lg:px-12 py-10 sm:py-12">

    {/* Header */}
    <div className="mb-5 text-center">
      <a
        href="https://cdn.ksu.edu.sa/ksu-subsites/dsd/TamkeenX.pdf"
        target="_blank"
        className="
          mx-auto mb-10 block max-w-[22rem]
          rounded-full bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500
          px-8 py-3 text-center text-2xl font-bold text-white
          shadow-[0_15px_30px_-15px_rgba(14,165,233,0.7)]
          transition-transform transition-colors duration-300
          hover:scale-[1.02] hover:shadow-[0_20px_36px_-18px_rgba(14,165,233,0.65)]
          focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-sky-200
        "
      >
          للإطلاع على برنامج الملتقى بصيغة PDF
        
      </a>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1c1b18] leading-tight">
        {activeIndex === 0 ? 'بناء القدرات لمستقبل تنافسي' : activeIndex === 1 ? 'بناء المهارات للجيل القادم: تمكين للمستقبل' : 'الأثر المجتمعي من خلال التدريب والتطوير'}
        
      </h1>

      {/* <p className="mt-4 text-xl text-[#6f6a5c]">
        المسرح الرئيسي
      </p> */}
    </div>

    {/* Day Switch */}
    <div className="flex justify-center mb-10" dir="rtl">
  <div className="inline-flex gap-3 sm:gap-6">
    {tabs.map((tab, idx) => (
      <button
        key={tab.label}
        onClick={() => setActiveIndex(idx)}
        className={`
          group relative px-3 sm:px-4 md:px-6 py-2 sm:py-3
          text-xl sm:text-2xl lg:text-3xl font-bold tracking-wide
          transition-all duration-300
          ${activeIndex === idx
            ? 'text-[#1c1b18]'
            : 'text-[#8a7f6a] hover:text-[#1c1b18]'
          }
        `}
      >
        {/* Label */}
        <span className="relative z-10 block text-2xl sm:text-3xl">
          {tab.label}
        </span>

        {/* Date */}
        <span className="block text-lg sm:text-xl font-medium mt-1 opacity-70">
          {tab.sub}
        </span>

        {/* Animated underline */}
        <span
          className={`
            absolute left-1/2 -bottom-1 h-[2px] bg-[#c6b89e]
            transition-all duration-300 ease-out
            ${activeIndex === idx
              ? 'w-full -translate-x-1/2'
              : 'w-0 group-hover:w-full -translate-x-1/2'
            }
          `}
        />

        {/* Hover lift */}
        <span
          className="
            pointer-events-none absolute inset-0
            transition-transform duration-300
            group-hover:-translate-y-0.5
          "
        />
      </button>
    ))}
  </div>
</div>

    {/* Cards */}
    <motion.div
      variants={stripContainer}
      className="grid gap-8 sm:gap-10 max-w-6xl mx-auto "
    >
      {activeSchedule.map((item, index) => {
        const speakers = [item.name1, item.name2, item.name3, item.name4].filter(Boolean)

        return (
          <motion.article
            key={`${item.time}-${index}`}
            variants={stripItem}
            whileHover={{ scale: 1.060 }}
            transition={{
              type: 'spring',
              stiffness: 260,
              damping: 20,
            }}
            className="
              group relative bg-white
              px-6 sm:px-8 lg:px-10 py-8
              shadow-[0_30px_60px_-40px_rgba(0,0,0,0.25)]
              will-change-transform
            "
          >
            {/* subtle editorial line */}
            <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-[#c6b89e] to-transparent" />

            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-between text-sm">
                {item.type && (
                  <span className="uppercase text-lg tracking-widest text-[#a08f6a]">
                    {item.type}
                  </span>
                )}
              </div>

              <div className="flex items-center justify-between gap-4">
                <p className="text-base sm:text-2xl leading-relaxed font-medium text-[#1c1b18]">
                  {item.title}
                </p>
                <span className="font-bold text-base sm:text-xl tracking-wide text-[#6f6a5c]">
                  {item.time}
                </span>
              </div>

              <div className="h-px w-16 bg-[#e6e2da]" />

              {speakers.length > 0 && (
                <div className="flex flex-wrap gap-3" dir="rtl">
                  {speakers.map((speaker, idx) => (
                    <span
                      key={`${speaker}-${idx}`}
                      className="
                        rounded-full bg-[#f7f2e8] text-[#1c1b18]
                        px-4 py-2 text-sm sm:text-base font-semibold
                        shadow-inner shadow-[#c6b89e]/30
                        border border-[#e6e2da]
                      "
                    >
                      {speaker}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </motion.article>
        )
      })}
    </motion.div>
  </div>
</motion.div>


    </div>
  )
}
